<template>
    <settings-control :label="label" expand>
        <slider
            :value="sliderIndex"
            :values="paddingValues"
            hide-marks
            @input="onInput"
        />
    </settings-control>
</template>

<script>
import SettingsControl from '@/components/settings/shared/settings-control';
import { tailwindConfig } from '@/data/tailwind';
import mapFilters from '@/utils/map-filters';
import { tailwindThemePropSort } from '@/utils/tailwind-helper';

const configValues = tailwindConfig.theme.padding;

export default {
    name: 'settings-control-padding',
    components: { SettingsControl },

    props: {
        side: {
            type: String,
            required: true,
        },

        value: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            paddingValues: Object.values(configValues)
                .filter(v => v.includes('rem'))
                .sort(tailwindThemePropSort)
                .slice(0, 12),
            sliderIndex: 0,
        };
    },

    computed: {
        label() {
            return `Padding ${ this.upperCase(this.side) }`;
        },
    },

    watch: {
        value: {
            handler(newVal) {
                this.sliderIndex = this.paddingValues.indexOf(newVal);
            },
            immediate: true,
        },
    },

    methods: {
        ...mapFilters(['upperCase']),

        onInput(index) {
            this.$emit('input', {
                tailwindDefinitionProp: 'padding',
                side: this.side,
                value: this.paddingValues[index],
            });
        },
    },
};
</script>
